// src/components/resources/tools/generators/FakeChat/FakeChatPreview.tsx

'use client'

import { useFakeChatState } from './FakeChatContext'
import { WhatsAppPreview } from './WhatsAppPreview'
import { MessengerPreview } from './MessengerPreview'
import { DiscordPreview } from './DiscordPreview'
import { MessagingPreview } from './MessagingPreview'
import { SlackPreview } from './SlackPreview'
import { IMessagePreview } from './IMessagePreview'

/**
 * Main fake chat preview component that renders different platform styles
 */
export function FakeChatPreview(): JSX.Element {
  const { conversation } = useFakeChatState()
  const platform = conversation.metadata.platform

  switch (platform) {
    case 'imessage':
      return <IMessagePreview />
    case 'slack':
      return <SlackPreview />
    case 'whatsapp':
      return <WhatsAppPreview />
    case 'messenger':
      return <MessengerPreview />
    case 'discord':
      return <DiscordPreview />
    case 'messaging':
      return <MessagingPreview />
    default: {
      // Exhaustiveness guard — adding a ChatPlatform without a case above is
      // a compile error here (mirrors the route's variant-base dispatch).
      // Messaging is the safe runtime fallback for malformed data.
      const _exhaustive: never = platform
      void _exhaustive
      return <MessagingPreview />
    }
  }
}
